import type { ProductUnit } from '@/api/suppliers'

/**
 * Καθαροί υπολογισμοί ποσότητας.
 *
 * Ζουν χωριστά από τα components ώστε το hot reload να μη χάνει την κατάσταση
 * της οθόνης κάθε φορά που αλλάζει ένας πίνακας τιμών.
 */

/** Πόσο ανεβαίνει ένα πάτημα, ανάλογα με τη μονάδα. */
export const STEP: Record<ProductUnit, number> = {
  piece: 1,
  kg: 0.5,
  case: 1,
  box: 1,
  pack: 1,
  liter: 1,
  bottle: 1,
  sack: 1,
}

/** Οι ποσότητες που ζητούνται στην πράξη, για επιλογή με ένα πάτημα. */
export const PRESETS: Record<ProductUnit, number[]> = {
  piece: [1, 2, 3, 5, 10, 20],
  kg: [0.5, 1, 2, 3, 5, 10],
  case: [1, 2, 3, 5, 10, 20],
  box: [1, 2, 3, 5, 10, 20],
  pack: [1, 2, 3, 5, 10, 20],
  liter: [1, 2, 3, 5, 10, 20],
  bottle: [1, 2, 3, 6, 12, 24],
  sack: [1, 2, 3, 5, 10],
}

/** «1.5» → «1,5» και «2.000» → «2». Ο Έλληνας γράφει με κόμμα. */
export function formatQty(value: string | number): string {
  const number = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(number)) return String(value)
  return String(Number(number.toFixed(3))).replace('.', ',')
}

/** Προσθέτει βήμα και κρατά το αποτέλεσμα καθαρό. Το μηδέν γίνεται κενό. */
export function addQuantity(current: string, delta: number): string {
  const next = (Number(current) || 0) + delta
  // Στρογγυλοποίηση στο τρίτο δεκαδικό: το 0.1 + 0.2 της IEEE δεν πρέπει να
  // φτάσει ποτέ στην οθόνη ως 0.30000000000000004.
  const clamped = Math.max(0, Number(next.toFixed(3)))
  return clamped === 0 ? '' : String(clamped)
}
